import { Component, OnInit } from '@angular/core';
import {Title } from "@angular/platform-browser";
declare var $: any;

@Component({
  selector: 'app-osha',
  templateUrl: './osha.component.html',
  styleUrls: ['./osha.component.css']
})
export class OshaComponent implements OnInit {

  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("OSHA - SFI Compliance, Inc");
    this.topposition();
  }

  //scroll to top of the page automatically
  topposition() {
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
  }

}
